import React from 'react';
import { BrainCircuit, Target, Zap, Network, BarChart3, Inbox } from 'lucide-react';

const services = [
  { icon: BrainCircuit, title: 'We find and contact 12,000 ideal prospects every month', desc: 'Our AI continuously identifies and engages in-market decision-makers who actually need what you sell, no bloated, recycled lists and no guesswork.', stat: '12,000+/mo', label: 'Contacted prospects' },
  { icon: Target, title: 'We put your offer in front of the right buyer, every time', desc: 'Verified contact data, enriched intent signals, and AI-personalized messaging that speaks directly to your exact ICP, not a generic template.', stat: '11.4%', label: 'Avg. reply rate' },
  { icon: Zap, title: 'We launch your full pipeline system in 14 days', desc: 'Domain warm-up, infrastructure, campaigns, sequences, live and optimizing in days, not months. Most clients see their first booked meeting inside week one.', stat: '14 days', label: 'To launch' },
  { icon: Network, title: 'We run email, LinkedIn, and phone as one motion', desc: 'Prospects hear from you across every channel they live on. Every touchpoint compounds, and every follow-up is written in your voice, at scale.', stat: '3-channel', label: 'Coordinated outreach' },
  { icon: BarChart3, title: 'We turn outbound into a spreadsheet, not a lottery', desc: 'Live dashboards, weekly strategy calls, and forecastable pipeline math. You know exactly what to expect next month before the month starts.', stat: '97%', label: 'Client retention' },
  { icon: Inbox, title: 'We get you in the inbox, and keep you out of spam', desc: 'Managed SPF/DKIM/DMARC, warmed sending domains, and rotating inbox pools. Your messages land where buyers actually read, the primary tab.', stat: '99.2%', label: 'Inbox placement' },
];

export default function Services() {
  return (
    <section id="services">
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">What you actually get</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            We handle the machine. <span className="text-gradient">You take the meetings.</span>
          </h2>
          <p className="reveal reveal-delay-2">Every part of a modern outbound motion, built, instrumented, and run for you. Here's exactly what ships when we're your lead-gen team.</p>
        </div>
        <div className="services-grid">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <article key={i} className="service-card reveal" style={{ transitionDelay: `${0.05 + (i % 3) * 0.08}s` }}>
                <div className="glow" />
                <div className="service-icon"><Icon size={22} /></div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <div className="service-stat">
                  <div className="v">{s.stat}</div>
                  <div className="l">{s.label}</div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
